const authHeader = () => {
  var root = JSON.parse(localStorage.getItem('persist:root'));
  var user = null;
  var currentSubsite = null;
  if(root != null && root.auth != null) {
    var auth = JSON.parse(root.auth);
    user = auth.user;
    currentSubsite = auth.currentSubsite;
    console.log("SUBSITE IN AUTH", auth, currentSubsite, user);
  }
  if(user && user !== undefined && user !== "undefined" && user.username) {
    if (user && user.accessToken) {
      return { "x-access-token" :user.accessToken, "subsite-id": currentSubsite.id, "x-suggested-filename" :""};
    } 
  } else if(currentSubsite) {
      return { "subsite-id": currentSubsite.id};
  } else {
    console.log("SUBSITE NOT SET");
    return {"subsite-id": -1};
  }
}

const authHeaderFromState = (theState) => {
  console.log("STATE", theState);
  if(theState.auth) {
    var user = theState.auth.user;
    var currentSubsite = theState.auth.currentSubsite;

    if(user && user !== undefined && user !== "undefined" && user.username) {
      if (user && user.accessToken) {
        return { "x-access-token" :user.accessToken, "subsite-id": currentSubsite.id, "x-suggested-filename" :""};
      } else {
        return {"subsite-id": 1};
      }
    } else if(currentSubsite) {
      return { "subsite-id": currentSubsite.id};
    } else {
      return {"subsite-id": 1};
    }
  } else {
    return {"subsite-id": 1};
  }
}


const authHeaderWithSubsite = (overrideSubsiteId) => {
  const base = authHeader();
  if (overrideSubsiteId) {
    return { ...base, "subsite-id": overrideSubsiteId };
  }
  return base;
};

const AuthHeader = {
  authHeader,
  authHeaderFromState,
  authHeaderWithSubsite
};
export default AuthHeader;
